import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { ButtonVariants } from "@medapro-types/common/common";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MButton',
  props: {
    variant: { default: "secondary" },
    designStyle: {},
    withIcon: { type: Boolean, default: false },
    onlyIcon: { type: Boolean, default: false },
    disabled: { type: Boolean }
  },
  emits: ["click", "focus", "mouseenter"],
  setup(__props: any, { emit }) {

const props = __props;





const classes = computed(() => {
  const defaultClasses = ["btn"];
  const variantClasses = [`btn-${props.variant}`];
  const conditionalClasses = { "btn-with-icon": props.withIcon, "btn-icon": props.onlyIcon, disabled: props.disabled };

  return [...defaultClasses, ...variantClasses, props.designStyle, conditionalClasses];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(classes.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event))),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus', $event))),
    disabled: _ctx.disabled
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode("Button")
    ])
  ], 42, _hoisted_1))
}
}

})